// Libraries
var React = require('react');
require('focus-visible');

// Components
var SkipLink = require('../../../common/SkipLink/SkipLink');

// Styles
require('./AccessibilityNav.scss');

class AccessNavigationModule extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			subNavigationExists: false,
		};
	}

	componentDidMount() {
		if (typeof window !== 'undefined') {
			setTimeout(()=> {
				var SubNavigation = document.querySelector("#sub-nav .SubNavigationBar__item__sub");
				if (SubNavigation) {
					this.setState({ subNavigationExists: true });
				}
			}, 500)
		}
	}

	render() {
		return (
			<ul id="nav-access">
				<li>
					<SkipLink><a href="#main">Skip to main content</a></SkipLink>
				</li>
				<li>
					<SkipLink skipTo="#main-nav .js-nav-open-button"><a href="#main-nav">Skip to main navigation</a></SkipLink>
				</li>
				{this.state.subNavigationExists && (
					<li>
						<SkipLink skipTo="#sub-nav .js-sub-nav-first-item"><a href="#sub-nav">Skip to sub navigation</a></SkipLink>
					</li>
				)}
			</ul>
		);
	}
};

module.exports = AccessNavigationModule;



// WEBPACK FOOTER //
// ./src/components/Navigation/AccessibilityNav/AccessibilityNavModule.js